import { forwardRef, MutableRefObject } from 'react';
import useAutoResizeTextArea from './hooks/useAutoResizeTextArea';

const TextAreaHeightAutoResize = forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ style, value, onChange, ...rest }, ref) => {
    const { textAreaHeight, handleOnChangeTextAreaValue } = useAutoResizeTextArea({
      resizeHeightToValue: `${style?.height}`,
      textAreaToResize: (ref as MutableRefObject<HTMLTextAreaElement>).current,
      value: `${value}`,
    });

    return (
      <textarea
        ref={ref}
        style={{ ...style, height: textAreaHeight }}
        onChange={(e) => {
          handleOnChangeTextAreaValue(e);
          onChange?.(e);
        }}
        value={value}
        {...rest}
      />
    );
  },
);

TextAreaHeightAutoResize.displayName = 'TextAreaHeightAutoResize';

export default TextAreaHeightAutoResize;
